import calmiRingMain from "@/assets/calmi-ring-main.png";

const steps = [
  {
    number: "01",
    title: "Choose Your Accessory",
    description: "Adjustable ring, Tree of Life bracelet, or complete set — find what suits you best.",
  },
  {
    number: "02",
    title: "Wear It Daily",
    description: "Our magnetic copper accessories adapt to your lifestyle seamlessly.",
  },
  {
    number: "03",
    title: "Feel the Balance",
    description: "Let the copper and integrated magnets naturally accompany you throughout your day.",
  },
];

export const HowItWorksSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-calim">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Image - lazy loaded */}
          <div className="order-2 lg:order-1">
            <img
              src={calmiRingMain}
              alt="CALMISTYLE Calmi Ring - Magnetic Copper Wellness Ring"
              loading="lazy"
              decoding="async"
              width={600}
              height={600}
              className="w-full aspect-square object-contain bg-secondary/30 rounded-2xl p-8"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="text-subhead mb-3 md:mb-4">How It Works</p>
            <h2 className="text-headline mb-6 md:mb-8">
              Simple, Natural, Effective
            </h2>

            <div className="space-y-6 md:space-y-8">
              {steps.map((step, index) => (
                <div
                  key={step.number}
                  className="flex gap-4 md:gap-6 animate-fade-up"
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  <div className="flex-shrink-0">
                    <span className="font-display text-2xl md:text-3xl text-muted-foreground/50">
                      {step.number}
                    </span>
                  </div>
                  <div>
                    <h3 className="font-display text-base md:text-lg mb-2">{step.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
